import { jsxs, jsx } from 'react/jsx-runtime';
import '../../../../text/types/index.esm.js';
import '../../../../text/heading/index.esm.js';
import '../../../../text/paragraph/index.esm.js';
import '../../../../text/subheading/index.esm.js';
import { EGDSText } from '../../../../text/text/index.esm.js';
import '../../../../utils/index_orig/index.esm.js';
import '../../../../utils/theme/theme-provider/index.esm.js';
import '../../../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../../../layout-flex/layout-flex-item/index.esm.js';
import { EGDSDateNumber } from '../../ToolkitComponents/date-number/index.esm.js';
import styles from '../../../../styles/uitk-egds-calendar.css';
import { classNames } from '../../../../utils/classnames/index.esm.js';
const DefaultDayTemplate = props => {
  const {
    day: {
      isPast,
      isPastMaxDate,
      isBeforeMinDate,
      isToday,
      day: dateDay
    },
    enablePastDates,
    dayData
  } = props;
  const {
    dateText
  } = dayData;
  const getClassNameList = classNames.bind(styles);
  const wrapperClassNames = getClassNameList('uitk-default-day-template', {
    'uitk-default-day-template-has-text': dateText
  });
  const getDateTextComponent = () => jsx(EGDSLayoutFlexItem, {
    children: jsx("div", {
      className: getClassNameList('uitk-default-day-template-text-area'),
      children: dateText.textValue && jsx(EGDSText, {
        size: 100,
        weight: dateText.textWeight,
        theme: dateText.textTheme,
        children: dateText.textValue
      })
    })
  });
  const getTheme = () => {
    if (isToday) {
      return 'today';
    }
    if (isPast && !enablePastDates || isPastMaxDate || isBeforeMinDate) {
      return 'muted';
    }
    return 'default';
  };
  return jsxs(EGDSLayoutFlex, {
    justifyContent: "center",
    alignItems: "center",
    direction: "column",
    blockSize: "full_size",
    className: wrapperClassNames,
    children: [jsx(EGDSLayoutFlexItem, {
      children: jsx(EGDSDateNumber, {
        theme: getTheme(),
        disabled: isPast && !enablePastDates || isPastMaxDate || isBeforeMinDate,
        children: dateDay
      })
    }), dateText && getDateTextComponent()]
  });
};
DefaultDayTemplate.canClick = (_dayData, day, enablePastDates) => !day.isPast && !day.isPastMaxDate && !day.isBeforeMinDate || enablePastDates && !day.isPastMaxDate && !day.isBeforeMinDate;
DefaultDayTemplate.canSpan = (_dayData, day, enablePastDates) => !day.isPast && !day.isPastMaxDate && !day.isBeforeMinDate || enablePastDates && !day.isPastMaxDate && !day.isBeforeMinDate;
DefaultDayTemplate.getAriaLabel = (_dayData, day, l10n, enablePastDates) => {
  const {
    isPast,
    isPastMaxDate,
    isBeforeMinDate,
    localeDateString
  } = day;
  return isPast && !enablePastDates || isPastMaxDate || isBeforeMinDate ? l10n.formatText('calendar.unavailable.a11yLabel', localeDateString) : localeDateString;
};
export { DefaultDayTemplate };